<template>
  <div class="page">
    <myHeader class="my-header"></myHeader>
    <div class="banner-box"></div>

    <!-- 第一页 -->
    <div class="container mobile">
      <!-- 关于我们 -->
      <div class="container2 fadeinup">
        <div class="fadeinup-titleb">ABOUT</div>
        <div class="content1">
          <div class="content1-left">
            <p>使命</p>
            <h3>守护和创新江苏美食</h3>
            <p>愿景</p>
            <h3>以糯米食品为核心的江苏节令食品领导品牌</h3>
            <p>价值观</p>
            <h3>客户至上 诚信正直 追求卓越</h3>
          </div>
          <div class="content1-right">
            <div class="content1-right-title">我们伍斋良田</div>
            <div>
              &nbsp;&nbsp;&nbsp;&nbsp;宿迁伍斋良田有限公司创立于2017年12月，公司位于中国・沭阳・南湖街道，是一家致力于粽子月饼等糕点类食品的食品生产和销售企业。公司有完善的食品生产车间，具备食品生产许可资质。公司在传承民族饮食文化的基础上不断创新，也在不断研发本土特色食品。
            </div>
            <div>
              &nbsp;&nbsp;&nbsp;&nbsp;主要产品：甜咸口味各类粽子，月饼，葱油饼等食品；
            </div>
          </div>
        </div>
      </div>

      <!-- 数据 -->
      <div class="about-data">
        <div class="about-data-cell">
          <div class="about-data-celld">2017</div>
          <div class="about-data-cellt">企业成立时间(年)</div>
        </div>
        <div class="about-data-cell">
          <div class="about-data-celld">100+</div>
          <div class="about-data-cellt">企业在职员工</div>
        </div>
        <div class="about-data-cell">
          <div class="about-data-celld">50+</div>
          <div class="about-data-cellt">专利证书</div>
        </div>
        <div class="about-data-cell">
          <div class="about-data-celld">40+</div>
          <div class="about-data-cellt">企业合作伙伴</div>
        </div>
        <div class="about-data-cell">
          <div class="about-data-celld">3000+</div>
          <div class="about-data-cellt">企业占地面积(㎡)</div>
        </div>
      </div>

      <!-- 产品列表 -->
      <div class="product">
        <div class="fadeinup-titleb">PRODUCT</div>
        <div class="product-title">产品列表</div>

        <div class="product-list">
          <div class="product-cell">
            <img class="product-img" src="../assets/product/cyb.webp" alt="" />
            <div class="product-name">葱油饼</div>
          </div>
          <div class="product-cell">
            <img class="product-img" src="../assets/product/zz.jpg" alt="" />
            <div class="product-name">粽子</div>
          </div>
          <div class="product-cell">
            <img class="product-img" src="../assets/product/yb.jpg" alt="" />
            <div class="product-name">月饼</div>
          </div>
        </div>

        <div class="product-more">了解更多</div>
      </div>

      <!-- 生产创新 -->

      <div class="innovation">
        <div class="fadeinup-titleb">VESION</div>
        <div class="innovation-title">生产创新 持续改进</div>

        <div class="innovation-content">
          <img class="innovation-img" src="../assets/cx.png" alt="" />
        </div>
      </div>

      <!-- 新闻 -->

      <div class="news">
        <div class="fadeinup-titleb">NEWS</div>
        <div class="news-title">新闻咨询</div>

        <div class="news-content">
          <!-- <div>
            <div>公司新产品研发</div>
            <div>2026年6月20日</div>
            <div></div>
          </div> -->
        </div>
      </div>

      <!--  -->
    </div>

    <myFooter class="footer"></myFooter>
  </div>
</template>

<script>
import myHeader from "../components/myHeader.vue";
import myFooter from "../components/myFooter.vue";

export default {
  name: "HomePage",
  components: {
    myHeader,
    myFooter,
  },
  data() {
    return {};
  },
  mounted() {
    this.$axios({
      method: "post",
      url: "/api/visit/client/createVisit",
      data: {
        pageName: "home",
      },
    }).then((res) => {
      console.log(res);
    });
  },
  methods: {
    backTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped lang="less">
.banner-box {
  text-align: center;
  background-color: #e9e9eb;
  margin-top: 90px;
}

.container {
  // height: calc(100vh - 90px);

  // 关于我们
  .container2 {
    max-width: 100%;
    width: 100%;
    margin: 0 auto;
    padding: 150px 8.33vw 20px 8.33vw;
    .fadeinup-titleb {
      width: 100%;
      font-size: 200px;
      font-family: "Micorsoft YaHei";
      font-weight: 700;
      text-align: center;
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      z-index: -1;
      background-image: linear-gradient(
        to bottom,
        rgba(217, 43, 53, 0.3),
        rgba(212, 216, 220, 0)
      );
      position: absolute;
      left: 0;
      top: 100px;
    }

    .content1 {
      display: flex;

      .content1-left {
        width: 48%;
        margin-right: 2%;

        h3 {
          color: #c8000b;
          margin-bottom: 4vh;
          font-size: 1.5rem;
        }
      }

      .content1-right {
        width: 50%;
        font-size: 18px;
        line-height: 44px;
        .content1-right-title {
          font-size: 40px;
          font-weight: 700;
          margin-bottom: 20px;
        }
      }
    }
  }

  // 关于我们数据
  .about-data {
    display: flex;
    justify-content: space-around;
    .about-data-cell {
      .about-data-celld {
        font-weight: 700;
        font-size: 72px;
        color: #d92b35;
        font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
      }
      .about-data-cellt {
        font-size: 16px;
      }
    }
  }

  // 产品
  .product {
    margin-top: 180px;
    position: relative;
    z-index: -1;
    .fadeinup-titleb {
      width: 100%;
      font-size: 200px;
      font-family: "Micorsoft YaHei";
      font-weight: 700;
      text-align: center;
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      z-index: -1;
      background-image: linear-gradient(
        to bottom,
        rgba(217, 43, 53, 0.3),
        rgba(212, 216, 220, 0)
      );
      position: absolute;
      left: 0;
      top: -150px;
    }

    .product-title {
      font-size: 40px;
      font-weight: 700;
      margin-top: 20px;
      text-align: center;
    }
    .product-list {
      display: flex;
      justify-content: space-around;
      margin-top: 40px;
      .product-cell {
        position: relative;
        .product-img {
          width: 300px;
          height: 300px;
        }
        .product-name {
          background-color: white;
          width: 100%;
          position: absolute;
          left: 0px;
          bottom: 0px;
          opacity: 0.8;
          padding: 10px 20px;
          font-size: 16px;
          font-weight: 700;
        }
      }
    }

    .product-more {
      color: #337ab7;
      margin-top: 0px;
      padding-top: 30px;
      text-align: right;
      margin: 0 10vw;
    }
  }

  // 创新
  .innovation {
    margin-top: 100px;
    position: relative;
    z-index: -1;
    .fadeinup-titleb {
      width: 100%;
      font-size: 200px;
      font-family: "Micorsoft YaHei";
      font-weight: 700;
      text-align: center;
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      z-index: -1;
      background-image: linear-gradient(
        to bottom,
        rgba(217, 43, 53, 0.3),
        rgba(212, 216, 220, 0)
      );
      position: absolute;
      left: 0;
      top: -100px;
    }
    .innovation-title {
      font-size: 40px;
      font-weight: 700;
      margin-top: 80px;
      padding-top: 50px;
      text-align: center;
    }
    .innovation-content {
      margin-top: 50px;
      width: 100%;
      text-align: center;
      border-radius: 20px;
      .innovation-img {
        width: 90%;
        border-radius: 20px;
      }
    }
  }

  // 新闻
  .news {
    margin-top: 100px;
    position: relative;
    z-index: -1;
    .fadeinup-titleb {
      width: 100%;
      font-size: 200px;
      font-family: "Micorsoft YaHei";
      font-weight: 700;
      text-align: center;
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      z-index: -1;
      background-image: linear-gradient(
        to bottom,
        rgba(217, 43, 53, 0.3),
        rgba(212, 216, 220, 0)
      );
      position: absolute;
      left: 0;
      top: -100px;
    }
    .news-title {
      font-size: 40px;
      font-weight: 700;
      margin-top: 80px;
      padding-top: 50px;
      text-align: center;
    }
    .news-content {
      margin-top: 50px;
      width: 100%;
      text-align: center;
      border-radius: 20px;
      .news-img {
        width: 90%;
        border-radius: 20px;
      }
    }
  }
  //
}

@media (min-width: 1200px) {
  .plate1 {
    width: 1170px;
    margin: 0 auto;
  }
}

.back-box {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 32px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  border-radius: 5px;
  background-color: black;
  color: white;
}

@media (max-width: 768px) {
  .mobile {
    .fadeinup-titleb {
      max-width: 100%;
      box-sizing: border-box;
      font-size: 60px !important;
      // top: 10px !important;
    }

    .container2 {
      padding: 50px 8.33vw 0 8.33vw;

      .content1 {
        display: block;

        .content1-left {
          width: 100%;
        }

        .content1-right {
          width: 100%;
        }
      }
    }
    .about-data {
      display: block;
      text-align: center;
    }

    .product {
      margin-top: 80px;
      .fadeinup-titleb {
        top: -35px;
      }
      .product-list {
        display: flex;
        flex-wrap: wrap;
      }
    }
    .innovation {
      margin-top: -60px !important;
      .fadeinup-titleb {
        top: 5px;
      }
    }

    .news {
      margin-top: 60px !important;
      .fadeinup-titleb {
        top: -40px;
      }
    }

    .news-title {
      font-size: 40px;
      font-weight: 700;
      margin-top: 0px !important;
      padding-top: 0px !important;
      text-align: center;
    }
  }

  .my-header {
    width: 100vw;
  }

  .banner {
    width: 100vw;
  }

  .footer {
    // height: 138px;
    width: 100vw;
  }
}
</style>
